export const loadPartial = (el, url, params = {}) => {
    if (!el.data("partialLoaded")) {
        console.log("partial not loaded yet.. loading");

        el.data("partialLoaded", true);

        $.get(url, params, (html) => {
            console.log("partial loaded");
            $(el).html(html);
        });
    }
};
